import React, { useState } from "react";
import { Search } from "lucide-react";
import { inputCls, labelCls } from "@/components/nds/windows/resident/ui";

const Group = ({ title, items, picked, toggle, setAll, testid }) => {
  if (!items.length) return null;
  const all = items.every((x) => picked.has(x.key));
  return (
    <div data-testid={`${testid}-group`}>
      <div className="flex items-center justify-between py-1">
        <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-nex-muted">{title}</span>
        <button type="button" onClick={() => setAll(items, !all)} data-testid={`${testid}-select-all`} className="font-mono text-[10px] tracking-[0.18em] uppercase text-nex-gold hover:underline">{all ? "Clear" : `All ${title.toLowerCase()}`}</button>
      </div>
      {items.map((x) => (
        <label key={x.key} className="flex items-center gap-2 py-1 px-1 rounded text-[12px] text-nex-silver hover:bg-white/5 cursor-pointer">
          <input type="checkbox" checked={picked.has(x.key)} onChange={() => toggle(x.key)} data-testid={`pmemo-pick-${x.key.replace(":", "-")}`} />
          <span className="truncate">{x.label}</span>
        </label>
      ))}
    </div>
  );
};

export default function RecipientPicker({ partners, staff, picked, setPicked, placeholder }) {
  const [q, setQ] = useState("");
  const m = (x) => x.label.toLowerCase().includes(q.trim().toLowerCase());
  const toggle = (k) => { const s = new Set(picked); s.has(k) ? s.delete(k) : s.add(k); setPicked(s); };
  const setAll = (items, on) => { const s = new Set(picked); items.forEach((x) => (on ? s.add(x.key) : s.delete(x.key))); setPicked(s); };
  const props = { picked, toggle, setAll };
  return (
    <div>
      <label className={labelCls}>To {picked.size > 0 && <span className="text-nex-gold" data-testid="pmemo-pick-count">· {picked.size} selected</span>}</label>
      <div className="relative mb-1">
        <Search className="h-3.5 w-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-nex-muted" />
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search names…" data-testid="pmemo-pick-search" className={`${inputCls} pl-8`} />
      </div>
      <div data-testid="pmemo-to" className="max-h-56 overflow-y-auto rounded border border-white/10 px-2 py-1 space-y-2">
        <Group title="Partners" items={partners.filter(m)} testid="pmemo-pick-partners" {...props} />
        <Group title="Staff" items={staff.filter(m)} testid="pmemo-pick-staff" {...props} />
        {!picked.size && placeholder && <p className="text-[11px] text-nex-muted py-1">{placeholder}</p>}
      </div>
    </div>
  );
}
